<template>
  <v-container>
    <v-row v-if="!MobileSize">
      <v-col cols="12" md="3" sm="4" :class="IpadProSize || IpadSize ? 'pr-0' : ''">
        <v-card class="mt-3" max-height="100%" min-height="700px">
          <v-list nav>
            <v-list-item style="cursor: pointer;">
              <v-list-item-icon :style="{'margin-right': IpadProSize || IpadSize ? '0px' : ''}">
                <v-icon color="">mdi-home</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title @click="changePath('/')" style="white-space: normal; font-weight: bold; font-size: 18px !important; line-height: 30px;">กลับไปหน้าการซื้อขาย</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item>
              <v-list-item-icon :style="{'margin-right': IpadProSize || IpadSize ? '0px' : ''}">
                <v-icon color="">mdi-storefront</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                  <v-list-item-title v-text="titleShop" style="white-space: normal; font-weight: bold; font-size: 18px !important; line-height: 24px;"></v-list-item-title>
                </v-list-item-content>
            </v-list-item>

            <v-list-group v-for="item in shop === 'Gracz' ? itemShopGracz : shop === 'Rattana' ? itemShopRattana : itemShop" :key="item.key"
                v-model="item.active" :prepend-icon="item.action" no-action color="#27AB9C">
                <template v-slot:activator>
                  <v-list-item-content>
                    <v-list-item-title v-text="item.title"
                      style="font-weight: bold; font-size: 18px !important; line-height: 30px;">
                    </v-list-item-title>
                  </v-list-item-content>
                </template>

                <v-list-item-group v-model="selectedItemShop" :mandatory="selectedItemShop!=-1">
                  <v-list-item v-for="child in item.items" :key="child.key" color="#27AB9C" dense class="pl-16"
                    style="font-size: 18px; line-height: 26px;">
                    <v-list-item-content @click="changePath(child.path)">
                      <v-list-item-action v-text="child.title"></v-list-item-action>
                    </v-list-item-content>
                  </v-list-item>
                </v-list-item-group>
            </v-list-group>
            <v-list-group v-for="item in shop === 'Gracz' ? itemCustomerDataGracz : shop === 'Rattana' ? itemCustomerDataRattana : itemCustomerData" :key="item.key"
                v-model="item.active" :prepend-icon="item.action" no-action color="#27AB9C">
                <template v-slot:activator>
                  <v-list-item-content>
                    <v-list-item-title v-text="item.title"
                      style="font-weight: bold; font-size: 18px !important; line-height: 30px;">
                    </v-list-item-title>
                  </v-list-item-content>
                </template>

                <v-list-item-group v-model="selectedItemCustomer" :mandatory="selectedItemCustomer!=-1">
                  <v-list-item v-for="child in item.items" :key="child.key" color="#27AB9C" dense class="pl-16"
                    style="font-size: 18px; line-height: 26px;">
                    <v-list-item-content @click="changePath(child.path)">
                      <v-list-item-action v-text="child.title"></v-list-item-action>
                    </v-list-item-content>
                  </v-list-item>
                </v-list-item-group>
            </v-list-group>
            <v-list-group v-for="item in shop === 'Gracz' ? itemOrderGracz : shop === 'Rattana' ? itemOrderRattana : itemOrder" :key="item.key"
                v-model="item.active" :prepend-icon="item.action" no-action color="#27AB9C">
                <template v-slot:activator>
                  <v-list-item-content>
                    <v-list-item-title v-text="item.title"
                      style="font-weight: bold; font-size: 18px !important; line-height: 30px;">
                    </v-list-item-title>
                  </v-list-item-content>
                </template>

                <v-list-item-group v-model="selectedItemOrder" :mandatory="selectedItemOrder!=-1">
                  <v-list-item v-for="child in item.items" :key="child.key" color="#27AB9C" dense class="pl-16"
                    style="font-size: 18px; line-height: 26px;">
                    <v-list-item-content @click="child.title === 'เข้าสู่ระบบ E-FACT' ? gotoEfact() : child.title === 'เข้าสู่ระบบ E-TAX' ? gotoEtax() : changePath(child.path)">
                      <v-list-item-action v-text="child.title"></v-list-item-action>
                    </v-list-item-content>
                  </v-list-item>
                </v-list-item-group>
            </v-list-group>
          </v-list>
        </v-card>
      </v-col>
      <v-col cols="12" md="9" sm="8">
        <v-main style="padding: 0px;">
          <v-container :class="IpadProSize || IpadSize ? 'px-0' : ''">
            <v-card max-height="100%" height="100%">
              <router-view></router-view>
            </v-card>
          </v-container>
        </v-main>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { Decode, Encode } from '@/services'
export default {
  data () {
    return {
      selectedItemShop: 0,
      selectedItemCustomer: 0,
      selectedItemOrder: 0,
      select: 0,
      itemShop: [
        {
          key: 1,
          action: 'mdi-cog',
          active: false,
          title: 'จัดการร้านค้า',
          items: [
            { key: 2, title: 'ข้อมูลร้านค้า', path: 'Order/SellerShopDetail', active: false },
            { key: 3, title: 'รายการสินค้า', path: 'Order/ProductListSaleOrder', active: false },
            { key: 4, title: 'จัดการหมวดหมู่สินค้า', path: 'Order/Category', active: false },
            { key: 5, title: 'จัดการโปรโมชัน', path: 'Order/Promotion', active: false },
            { key: 6, title: 'E-Tax Credential', path: 'Order/EtaxCredential', active: false },
            { key: 7, title: 'จัดการข้อมูลผู้ใช้งาน', path: 'Order/ManageUser', active: false }
          ]
        }
      ],
      itemCustomerData: [
        {
          key: 8,
          action: 'mdi-account',
          active: false,
          title: 'ข้อมูลลูกค้า',
          items: [
            { key: 9, title: 'จัดการกลุ่มลูกค้า', path: 'Order/ManageGroupCustomer', active: false },
            { key: 10, title: 'รายชื่อลูกค้า', path: 'Order/CustomerList', active: false }
          ]
        }
      ],
      itemOrder: [
        {
          key: 11,
          action: 'mdi-file-document-outline',
          active: false,
          title: 'รายการสั่งซื้อสินค้า',
          items: [
            { key: 12, title: 'รายการสั่งซื้อสินค้า', path: 'Order/OrderList', active: false },
            { key: 13, title: 'รายการสั่งซื้อสินค้าที่ถูกลบ', path: 'Order/DeletedOrderList', active: false },
            { key: 14, title: 'แดชบอร์ดรายงานการสั่งซื้อ', path: 'Order/AdminDashbord' },
            { key: 15, title: 'เข้าสู่ระบบ E-TAX', path: '' },
            { key: 16, title: 'เข้าสู่ระบบ E-FACT', path: '' }
          ]
        }
      ],
      itemShopGracz: [
        {
          key: 1,
          action: 'mdi-cog',
          active: false,
          title: 'จัดการร้านค้า',
          items: [
            { key: 2, title: 'ข้อมูลร้านค้า', path: 'Order/SellerShopDetail', active: false },
            { key: 3, title: 'รายการสินค้า', path: 'Order/ProductList', active: false },
            { key: 4, title: 'จัดการหมวดหมู่สินค้า', path: 'Order/Category', active: false },
            { key: 5, title: 'จัดการโปรโมชัน', path: 'Order/Promotion', active: false },
            { key: 6, title: 'จัดการข้อมูลผู้ใช้งาน', path: 'Order/ManageUser', active: false }
          ]
        }
      ],
      itemCustomerDataGracz: [
        {
          key: 7,
          action: 'mdi-account',
          active: false,
          title: 'ข้อมูลลูกค้า',
          items: [
            { key: 8, title: 'จัดการกลุ่มลูกค้า', path: 'Order/ManageGroupCustomer', active: false },
            { key: 9, title: 'รายชื่อลูกค้า', path: 'Order/CustomerList', active: false }
          ]
        }
      ],
      itemOrderGracz: [
        {
          key: 10,
          action: 'mdi-file-document-outline',
          active: false,
          title: 'รายการสั่งซื้อสินค้า',
          items: [
            { key: 11, title: 'รายการสั่งซื้อสินค้า', path: 'Order/OrderList', active: false },
            { key: 12, title: 'รายการสั่งซื้อสินค้าที่ถูกลบ', path: 'Order/DeletedOrderList', active: false },
            { key: 13, title: 'แดชบอร์ดรายงานการสั่งซื้อ', path: 'Order/AdminDashbord' }
          ]
        }
      ],
      itemShopRattana: [
        {
          key: 1,
          action: 'mdi-cog',
          active: false,
          title: 'จัดการร้านค้า',
          items: [
            { key: 2, title: 'ข้อมูลร้านค้า', path: 'Order/SellerShopDetail', active: false },
            { key: 3, title: 'รายการสินค้า', path: 'Order/ProductList', active: false },
            { key: 4, title: 'จัดการหมวดหมู่สินค้า', path: 'Order/Category', active: false },
            { key: 5, title: 'จัดการโปรโมชัน', path: 'Order/Promotion', active: false },
            { key: 6, title: 'E-Tax Credential', path: 'Order/EtaxCredential', active: false },
            { key: 7, title: 'จัดการข้อมูลผู้ใช้งาน', path: 'Order/ManageUser', active: false }
          ]
        }
      ],
      itemCustomerDataRattana: [
        {
          key: 8,
          action: 'mdi-account',
          active: false,
          title: 'ข้อมูลลูกค้า',
          items: [
            { key: 9, title: 'จัดการกลุ่มลูกค้า', path: 'Order/ManageGroupCustomer', active: false },
            { key: 10, title: 'รายชื่อลูกค้า', path: 'Order/CustomerList', active: false }
          ]
        }
      ],
      itemOrderRattana: [
        {
          key: 11,
          action: 'mdi-file-document-outline',
          active: false,
          title: 'รายการสั่งซื้อสินค้า',
          items: [
            { key: 12, title: 'รายการสั่งซื้อสินค้า', path: 'Order/OrderList', active: false },
            { key: 13, title: 'รายการสั่งซื้อสินค้าที่ถูกลบ', path: 'Order/DeletedOrderList', active: false },
            { key: 14, title: 'แดชบอร์ดรายงานการสั่งซื้อ', path: 'Order/AdminDashbord' },
            { key: 15, title: 'เข้าสู่ระบบ E-TAX', path: '' },
            { key: 16, title: 'เข้าสู่ระบบ E-FACT', path: '' }
          ]
        }
      ],
      shopName: '',
      shopID: '',
      orderNumber: '',
      customerId: '',
      graczData: '',
      titleShop: '',
      isGracz: '',
      shop: '',
      userDetailSelling: '',
      userId: null
    }
  },
  created () {
    this.$EventBus.$emit('getPath')
    this.$EventBus.$on('changeNav', this.changeNav)
    this.$EventBus.$on('changeNavEtax', this.changeNavEtax)
    this.$EventBus.$on('changeNavSelleShop', this.changeNavSelleShop)
    this.$EventBus.$emit('changeAppBarGracz')
    this.getShopName()
    // set seller shop name
    if (localStorage.getItem('oneData') === null || localStorage.getItem('UserDetailSelling') === null) {
      this.$EventBus.$emit('changeAppBarPanit')
      this.$router.push({ path: '/' }).catch(() => {})
    }
    if (localStorage.getItem('UserDetailSelling') !== null) {
      this.userDetailSelling = JSON.parse(Decode.decode(localStorage.getItem('UserDetailSelling')))
      this.isGracz = this.userDetailSelling.is_gracz
    }
    this.checkShop()
    this.selectedItemShop = -1
    this.selectedItemCustomer = -1
    this.selectedItemOrder = -1
    this.changeNav()
  },
  mounted () {
    this.$EventBus.$on('getGraczShopName', this.getShopName)
    window.scrollTo(0, 0)
    // this.getShopName()
  },
  watch: {
    selectedItem (val) {
      // console.log(val)
    },
    MobileSize (val) {
      if (this.$router.currentRoute.name === 'GraczUserProfileDetail') {
        if (val === true) {
          this.$router.push({ path: '/Order/UserProfileDetailMobile' }).catch(() => {})
        } else {
          this.$router.push({ path: '/Order/UserProfileDetail' }).catch(() => {})
        }
      } else if (this.$router.currentRoute.name === 'GraczSellerShopDetail') {
        if (val === true) {
          this.$router.push(`/Order/SellerShopDetailMobile/${this.shopName}-${this.shopID}`).catch(() => {})
        } else {
          this.$router.push(`/Order/SellerShopDetail/${this.shopName}-${this.shopID}`).catch(() => {})
        }
      } else if (this.$router.currentRoute.name === 'GraczEditEditSellerShop') {
        if (val === true) {
          this.$router.push('/Order/EditSellerShopMobile').catch(() => {})
        } else {
          this.$router.push('/Order/EditSellerShop').catch(() => {})
        }
      } else if (this.$router.currentRoute.name === 'GraczProductList') {
        if (val === true) {
          this.$router.push({ path: '/Order/ProductListMobile' }).catch(() => {})
        } else {
          this.$router.push({ path: '/Order/ProductList' }).catch(() => {})
        }
      } else if (this.$router.currentRoute.name === 'GraczProductListSaleOrder') {
        if (val === true) {
          this.$router.push({ path: '/Order/ProductListSaleOrderMobile' }).catch(() => {})
        } else {
          this.$router.push({ path: '/Order/ProductListSaleOrder' }).catch(() => {})
        }
      } else if (this.$router.currentRoute.name === 'GraczManageProduct') {
        // console.log(this.$route.query)
        var productStatus = this.$route.query.Status
        var productID = this.$route.query.ProductID
        if (val === true) {
          if (productStatus === 'Edit') {
            this.$router.push({ path: `/Order/manageproductMobile?Status=Edit&ShopID=${this.shopID}&ProductID=${productID}` }).catch(() => {})
          } else {
            this.$router.push({ path: `/Order/ManageProductMobile?Status=Create&ShopID=${this.shopID}` }).catch(() => {})
          }
        } else {
          this.$router.push({ path: '/Order/ManageProduct' }).catch(() => {})
        }
      } else if (this.$router.currentRoute.name === 'GraczManageProductSaleOrder') {
        // console.log(this.$route.query)
        console.log('sidebar', this.$route.query.ProductID)
        var productSaleStatus = this.$route.query.Status
        var productSaleID = this.$route.query.ProductID
        if (val === true) {
          if (productSaleStatus === 'Edit') {
            this.$router.push({ path: `/Order/ManageProductSaleOrderMobile?Status=Edit&ShopID=${this.shopID}&ProductID=${productSaleID}` }).catch(() => {})
          } else {
            this.$router.push({ path: `/Order/ManageProductSaleOrderMobile?Status=Create&ShopID=${this.shopID}` }).catch(() => {})
          }
        } else {
          this.$router.push({ path: '/Order/ManageProductSaleOrder' }).catch(() => {})
        }
      } else if (this.$router.currentRoute.name === 'GraczOrderList') {
        if (val === true) {
          this.$router.push({ path: '/Order/OrderListMobile' }).catch(() => {})
        } else {
          this.$router.push({ path: '/Order/OrderList' }).catch(() => {})
        }
      } else if (this.$router.currentRoute.name === 'SaleOrderCreditNote') {
        if (val === true) {
          this.$router.push({ path: '/Order/CreditNoteMobile' }).catch(() => {})
        } else {
          this.$router.push({ path: '/Order/CreditNote' }).catch(() => {})
        }
      } else if (this.$router.currentRoute.name === 'GraczOrderDetail') {
        this.orderNumber = this.$route.query.orderNumber
        if (val === true) {
          this.$router.push({ path: `/Order/OrderDetailMobile?orderNumber=${this.orderNumber}` }).catch(() => {})
        } else {
          this.$router.push({ path: `/Order/OrderDetail?orderNumber=${this.orderNumber}` }).catch(() => {})
        }
      } else if (this.$router.currentRoute.name === 'GraczDeletedOrderList') {
        if (val === true) {
          this.$router.push({ path: '/Order/DeletedOrderListMobile' }).catch(() => {})
        } else {
          this.$router.push({ path: '/Order/DeletedOrderList' }).catch(() => {})
        }
      } else if (this.$router.currentRoute.name === 'GraczDeletedOrderDetail') {
        this.orderNumber = this.$route.query.orderNumber
        if (val === true) {
          this.$router.push({ path: `/Order/DeletedOrderDetailMobile?orderNumber=${this.orderNumber}` }).catch(() => {})
        } else {
          this.$router.push({ path: `/Order/DeletedOrderDetail?orderNumber=${this.orderNumber}` }).catch(() => {})
        }
      } else if (this.$router.currentRoute.name === 'GraczManageGroupCustomer') {
        if (val === true) {
          this.$router.push({ path: '/Order/ManageGroupCustomerMobile' }).catch(() => {})
        } else {
          this.$router.push({ path: '/Order/ManageGroupCustomer' }).catch(() => {})
        }
      } else if (this.$router.currentRoute.name === 'GraczCustomerList') {
        if (val === true) {
          this.$router.push({ path: '/Order/CustomerListMobile' }).catch(() => {})
        } else {
          this.$router.push({ path: '/Order/CustomerList' }).catch(() => {})
        }
      } else if (this.$router.currentRoute.name === 'GraczCustomerDetail') {
        this.customerId = this.$route.query.cusid
        if (val === true) {
          this.$router.push({ path: `/Order/CustomerDetailMobile?cusid=${this.customerId}` }).catch(() => {})
        } else {
          this.$router.push({ path: `/Order/CustomerDetail?cusid=${this.customerId}` }).catch(() => {})
        }
      } else if (this.$router.currentRoute.name === 'GraczImportCustomerData') {
        if (val === true) {
          this.$router.push({ path: '/Order/ImportCustomerDataMobile' }).catch(() => {})
        } else {
          this.$router.push({ path: '/Order/ImportCustomerData' }).catch(() => {})
        }
      } else if (this.$router.currentRoute.name === 'GraczCategory') {
        if (val === true) {
          this.$router.push({ path: '/Order/CategoryMobile' }).catch(() => {})
        } else {
          this.$router.push({ path: '/Order/Category' }).catch(() => {})
        }
      } else if (this.$router.currentRoute.name === 'GraczPromotion') {
        if (val === true) {
          this.$router.push({ path: '/Order/PromotionMobile' }).catch(() => {})
        } else {
          this.$router.push({ path: '/Order/Promotion' }).catch(() => {})
        }
      } else if (this.$router.currentRoute.name === 'GraczManagePromotion') {
        // console.log(this.$route.query)
        var promotionStatus = this.$route.query.Status
        var promotionID = this.$route.query.PromotionID
        if (val === true) {
          if (promotionStatus === 'edit') {
            this.$router.push({ path: `/Order/ManagePromotionMobile?PromotionID=${promotionID}&Status=edit&ShopID=${this.shopID}` }).catch(() => {})
          } else {
            this.$router.push({ path: `/Order/ManagePromotionMobile?Status=create&ShopID=${this.shopID}` }).catch(() => {})
          }
        }
      } else if (this.$router.currentRoute.name === 'GraczManageUser') {
        if (val === true) {
          this.$router.push({ path: '/Order/ManageUserMobile' }).catch(() => {})
        } else {
          this.$router.push({ path: '/Order/ManageUser' }).catch(() => {})
        }
      } else if (this.$router.currentRoute.name === 'AdminGraczDashbord') {
        if (val === true) {
          this.$router.push({ path: '/Order/AdminDashbordMobile' }).catch(() => {})
        } else {
          this.$router.push({ path: '/Order/AdminDashbord' }).catch(() => {})
        }
      } else if (this.$router.currentRoute.name === 'GraczEtaxCredential') {
        if (val === true) {
          this.$router.push({ path: '/Order/EtaxCredentialMobile' }).catch(() => {})
        } else {
          this.$router.push({ path: '/Order/EtaxCredential' }).catch(() => {})
        }
      }
    }
  },
  computed: {
    MobileSize () {
      const { xs } = this.$vuetify.breakpoint
      return !!xs
    },
    IpadSize () {
      const { sm } = this.$vuetify.breakpoint
      return !!sm
    },
    IpadProSize () {
      const { md } = this.$vuetify.breakpoint
      return !!md
    }
  },
  methods: {
    async getShopName () {
      this.$store.commit('openLoader')
      var response = await this.$store.state.ModuleGraczUser.stateGraczUserDetail
      if (response.message === 'Get user detail selling success') {
        this.userId = response.data.user_id
        // console.log('userID', this.userId)
        this.$store.commit('closeLoader')
        if (localStorage.getItem('UserDetailSelling') !== null) {
          var userDetailSelling = JSON.parse(Decode.decode(localStorage.getItem('UserDetailSelling')))
          var shopIndex = response.data.list_shop_detail.findIndex(e => e.seller_shop_id === userDetailSelling.seller_shop_id)
          await localStorage.setItem('GraczShopData', Encode.encode(response.data.list_shop_detail[shopIndex]))
          await localStorage.setItem('UserDetailSelling', Encode.encode(response.data.list_shop_detail[shopIndex]))
        }
        const customerDetail = {
          cus_name: '',
          cus_id: '',
          cus_code: '',
          channel_name: '',
          channel_id: '',
          cart_data: '',
          cus_address: '',
          onlinePurchaseStatus: true
        }
        await localStorage.setItem('OnlinePurchase', Encode.encode(customerDetail))
        var shop = JSON.parse(Decode.decode(localStorage.getItem('GraczShopData')))
        this.shopName = shop.shop_name
        this.shopID = shop.seller_shop_id
        this.titleShop = this.shopName
      } else if (response.message === 'This user is unauthorized.') {
        this.$store.commit('closeLoader')
        this.$swal.fire({ icon: 'warning', text: 'กรุณาเข้าสู่ระบบใหม่อีกครั้ง', showConfirmButton: false, timer: 2000 })
        window.location.assign('/')
      } else if (response.message === 'Not access this function.') {
        this.$store.commit('closeLoader')
        this.$swal.fire({ icon: 'warning', text: 'มีการเปลี่ยนแปลงตำแหน่ง หรือเปลี่ยนแปลงสิทธิ์การใช้งาน กรุณาลองใหม่อีกครั้ง', showConfirmButton: false, timer: 2000 })
        window.location.assign('/')
      } else {
        this.$store.commit('closeLoader')
        var [msg, iconMsg] = this.getErrorMsg(response.message)
        this.$swal.fire({ icon: iconMsg, text: msg, showConfirmButton: false, timer: 2000 })
      }
    },
    getErrorMsg (msg) {
      if (msg === 'This user is unauthorized.') {
        return ('กรุณาเข้าสู่ระบบใหม่อีกครั้ง', 'warning')
      } else if (msg === 'Channel not found. Please check and try again.') {
        return ['ไม่พบ Channel โปรดเช็คแล้วลองใหม่อีกครั้ง', 'warning']
      } else if (msg === 'Shop not found. Please check and try again.') {
        return ['ไม่พบร้านค้า โปรดเช็คแล้วลองใหม่อีกครั้ง', 'warning']
      } else if (msg === 'Employee not found. Please check and try again.') {
        return ['ไม่พบพนักงาน โปรดเช็คแล้วลองใหม่อีกครั้ง', 'warning']
      } else if (msg === 'Seller shop not found.' || msg === 'Not Found Seller Shop') {
        return ['ไม่พบร้านค้า', 'warning']
      } else {
        return [msg, 'error']
      }
    },
    async changePath (val) {
      this.checkActive(val)
      if (val === '/') {
        await localStorage.removeItem('OnlinePurchase')
        this.$EventBus.$emit('OnlinePurchase')
        this.$router.push({ path: `${val}` }).catch(() => {})
      } else if (val === 'Order/SellerShopDetail') {
        this.$router.push(`/Order/SellerShopDetail/${this.shopName}-${this.shopID}`).catch(() => {})
      } else {
        this.$router.push(`/${val}`).catch(() => {})
      }
    },
    checkActive (val) {
      if (val === 'Order/SellerShopDetail') {
        this.selectedItemCustomer = -1
        this.selectedItemOrder = -1
      } else if (val === 'Order/ProductList') {
        this.selectedItemCustomer = -1
        this.selectedItemOrder = -1
      } else if (val === 'Order/Category') {
        this.selectedItemCustomer = -1
        this.selectedItemOrder = -1
      } else if (val === 'Order/Promotion') {
        this.selectedItemCustomer = -1
        this.selectedItemOrder = -1
      } else if (val === 'Order/EtaxCredential') {
        this.selectedItemCustomer = -1
        this.selectedItemOrder = -1
      } else if (val === 'Order/ManageUser') {
        this.selectedItemCustomer = -1
        this.selectedItemOrder = -1
      } else if (val === 'Order/ManageGroupCustomer') {
        this.selectedItemShop = -1
        this.selectedItemOrder = -1
      } else if (val === 'Order/CustomerList') {
        this.selectedItemShop = -1
        this.selectedItemOrder = -1
      } else if (val === 'Order/OrderList') {
        this.selectedItemShop = -1
        this.selectedItemCustomer = -1
      } else if (val === 'Order/DeletedOrderList') {
        this.selectedItemShop = -1
        this.selectedItemCustomer = -1
      } else if (val === 'Order/AdminDashbord') {
        this.selectedItemShop = -1
        this.selectedItemCustomer = -1
      }
    },
    checkShop () {
      if (this.userDetailSelling.is_gracz === 'yes') {
        this.shop = 'Gracz'
      } else {
        if (this.userDetailSelling.is_rattana === 'yes') {
          this.shop = 'Rattana'
        } else {
          this.shop = 'Sale Order'
        }
      }
    },
    changeNav () {
      if (this.$router.currentRoute.name === 'GraczSellerShopDetail') {
        this.selectedItemShop = 0
        this.select = 0
        if (this.shop === 'Gracz') {
          this.itemShopGracz[0].active = true
        } else if (this.shop === 'Rattana') {
          this.itemShopRattana[0].active = true
        } else {
          this.itemShop[0].active = true
        }
      } else if (this.$router.currentRoute.name === 'GraczProductList' || this.$router.currentRoute.name === 'GraczProductListSaleorder' || this.$router.currentRoute.name === 'GraczManageProduct' || this.$router.currentRoute.name === 'GraczManageProductSaleOrder' || this.$router.currentRoute.name === 'GraczImportPanitProduct') {
        this.selectedItemShop = 1
        this.select = 1
        // gracz และ rattana ไม่มีเรื่อง stock
        // console.log('this.shop===', this.shop)
        if (this.shop === 'Gracz') {
          this.itemShopGracz[0].active = true
        } else if (this.shop === 'Rattana') {
          this.itemShopRattana[0].active = true
        } else {
          this.itemShop[0].active = true
        }
      } else if (this.$router.currentRoute.name === 'GraczCategory') {
        this.select = 2
        this.selectedItemShop = 2
        if (this.shop === 'Gracz') {
          this.itemShopGracz[0].active = true
        } else if (this.shop === 'Rattana') {
          this.itemShopRattana[0].active = true
        } else {
          this.itemShop[0].active = true
        }
      } else if (this.$router.currentRoute.name === 'GraczPromotion' || this.$router.currentRoute.name === 'GraczManagePromotion') {
        this.select = 3
        this.selectedItemShop = 3
        if (this.shop === 'Gracz') {
          this.itemShopGracz[0].active = true
        } else if (this.shop === 'Rattana') {
          this.itemShopRattana[0].active = true
        } else {
          this.itemShop[0].active = true
        }
      } else if (this.$router.currentRoute.name === 'GraczEtaxCredential') {
        this.select = 4
        this.selectedItemShop = 4
        if (this.shop === 'Gracz') {
          this.itemShopGracz[0].active = true
        } else if (this.shop === 'Rattana') {
          this.itemShopRattana[0].active = true
        } else {
          this.itemShop[0].active = true
        }
      } else if (this.$router.currentRoute.name === 'GraczManageUser') {
        if (this.shop === 'Gracz') {
          this.select = 4
          this.selectedItemShop = 4
          this.itemShopGracz[0].active = true
        } else if (this.shop === 'Rattana') {
          this.select = 5
          this.selectedItemShop = 5
          this.itemCustomerDataRattana[0].active = true
        } else {
          this.select = 5
          this.selectedItemShop = 5
          this.itemShop[0].active = true
        }
      } else if (this.$router.currentRoute.name === 'GraczManageGroupCustomer') {
        this.select = 0
        this.selectedItemCustomer = 0
        if (this.shop === 'Gracz') {
          this.itemCustomerDataGracz[0].active = true
        } else if (this.shop === 'Rattana') {
          this.itemCustomerDataRattana[0].active = true
        } else {
          this.itemCustomerData[0].active = true
        }
      } else if (this.$router.currentRoute.name === 'GraczCustomerList' || this.$router.currentRoute.name === 'GraczCustomerDetail' || this.$router.currentRoute.name === 'GraczImportCustomerData') {
        this.select = 1
        this.selectedItemCustomer = 1
        if (this.shop === 'Gracz') {
          this.itemCustomerDataGracz[0].active = true
        } else if (this.shop === 'Rattana') {
          this.itemCustomerDataRattana[0].active = true
        } else {
          this.itemCustomerData[0].active = true
        }
      } else if (this.$router.currentRoute.name === 'GraczOrderList' || this.$router.currentRoute.name === 'GraczOrderDetail' || this.$router.currentRoute.name === 'SaleOrderCreditNote') {
        this.selectedItemOrder = 0
        this.select = 0
        if (this.shop === 'Gracz') {
          this.itemOrderGracz[0].active = true
        } else if (this.shop === 'Rattana') {
          this.itemOrderRattana[0].active = true
        } else {
          this.itemOrder[0].active = true
        }
      } else if (this.$router.currentRoute.name === 'GraczDeletedOrderList' || this.$router.currentRoute.name === 'GraczDeletedOrderDetail') {
        this.select = 1
        this.selectedItemOrder = 1
        if (this.shop === 'Gracz') {
          this.itemOrderGracz[0].active = true
        } else if (this.shop === 'Rattana') {
          this.itemOrderRattana[0].active = true
        } else {
          this.itemOrder[0].active = true
        }
      } else if (this.$router.currentRoute.name === 'AdminGraczDashbord') {
        this.select = 2
        this.selectedItemOrder = 2
        if (this.shop === 'Gracz') {
          this.itemOrderGracz[0].active = true
        } else if (this.shop === 'Rattana') {
          this.itemOrderRattana[0].active = true
        } else {
          this.itemOrder[0].active = true
        }
      }
    },
    changeNavEtax () {
      this.checkShop()
      this.select = 4
      this.selectedItemShop = 4
      if (this.shop === 'Sale Order') {
        this.itemShop[0].active = true
      } else if (this.shop === 'Rattana') {
        this.itemShopRattana[0].active = true
      }
      this.selectedItemOrder = -1
    },
    changeNavSelleShop () {
      this.select = 0
      this.selectedItemShop = 0
      if (this.shop === 'Gracz') {
        this.itemShopGracz[0].active = true
      } else if (this.shop === 'Rattana') {
        this.itemShopRattana[0].active = true
      } else {
        this.itemShop[0].active = true
      }
      this.selectedItemOrder = -1
      this.selectedItemCustomer = -1
    },
    closeMenu (val) {
      this.selectedItem = val
    },
    async gotoEfact () {
      await this.$store.dispatch('actionsLoginBySharedTokenEfac')
      var response = await this.$store.state.ModuleSaleOrderEtax.stateLoginBySharedTokenEfac
      window.open(response.data.link, '_blank')
    },
    async gotoEtax () {
      if (process.env.VUE_APP_DOMAIN === 'https://panit.one.th/') {
        // E-Tax PRD
        window.open('https://etax.one.th/portal/login', '_blank')
      } else {
        // E-Tax UAT
        window.open('https://devinet-etax.one.th/portal/login', '_blank')
      }
    }
  }
}
</script>

<style scoped>
.backgroundPage{
background-color: #F6F6F6;
}
.container {
max-width: 100%;
}
</style>
